import { List } from '@acies/core';
import type { IPresentedParameter } from '../../../domain/configurations';
import { ConfiguratorModel } from '../configurator.model';
import AnswerItemRenderer from './answer-item-renderer';

export default class AnswersList extends List<IPresentedParameter> {
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		// the scrollbar is there from the first row rather than appearing at the one that overflows,
		// so the rows never shift under the header, which is aligned to it once
		this.alwaysShowVerticalScrollbar = true;
		// The parameters of whichever position is selected, which the machine writes on every
		// selection. Handed the collection itself rather than its items, so the list re-renders
		// from a subscription without anyone telling it to — the same as PositionsList.
		this.data = ConfiguratorModel.currentParameters;
		this.ItemRenderer = AnswerItemRenderer;
	}

	/**
	 * The row showing a parameter, or undefined when none is.
	 *
	 * For whoever has something to say about an answer after the row has given it — the machine, when the API would not take one. List keeps the same lookup to itself, since a row is its own business; it is made public here because this list's rows are where a refusal has to be shown, and there is nowhere else to show
	 * it.
	 *
	 * Undefined is the ordinary case for an answer that was overtaken: the rows are pooled and re-dealt every time the data changes, so a parameter from a position the user has since left is drawn by no row at all.
	 */
	public rendererFor(parameter: IPresentedParameter): AnswerItemRenderer | undefined {
		const itemRenderer = this.itemRendererFor(parameter);
		return itemRenderer instanceof AnswerItemRenderer ? itemRenderer : undefined;
	}
}
customElements.define('cf-answers-list', AnswersList);
